import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos/generated-paths';
import type { IPolicyEligibleServicesDto } from '@/dtos/models';

export const QUERY_KEY = 'GET_ELIGIBLE_SERVICES';

const SERVICE_TYPES = ['MANUAL_CLAIM', 'HEALTH_PLAN'];

const useGetEligibleServicesQuery = (policyId?: number | string) => {
  const { data, isLoading, isSuccess } = useQuery(
    [QUERY_KEY, policyId],
    () =>
      api.get<IPolicyEligibleServicesDto[]>(API_URL.PLANS_SERVICES, {
        params: {
          policy_ids: policyId,
          service_types: SERVICE_TYPES.join(','),
        },
      }),
    {
      enabled: Boolean(policyId),
    },
  );

  return { data: data?.data || [], isLoading, isSuccess };
};

export default useGetEligibleServicesQuery;
